/**
 * Estrae e inietta tutti i <script> da una stringa HTML
 * @param {string} htmlString — la stringa HTML contenente <script>…</script>
 * @param {string} selector — selettore CSS di dove appendere (es. 'head', 'body', '.mio-footer')
 */
export function insertScripts(htmlString, selector) {
  // 1) Parse della stringa HTML
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, 'text/html');
  
  // 2) Trova il container di destinazione
  const container = document.querySelector(selector);
  if (!container) {
    console.error(`insertScripts: nessun elemento trovato per selector "${selector}"`);
    return;
  }

  // 3) Estrai tutti gli <script>
  const scripts = Array.from(doc.querySelectorAll('script'));

  scripts.forEach(oldScript => {
    // 3a) Se ha src, evita di reinserire duplicati
    if (oldScript.src) {
      const exists = document.querySelector(`script[src="${oldScript.src}"]`);
      if (exists) return;
    }
    
    // 3b) Crea il nuovo <script> e copia gli attributi
    const newScript = document.createElement('script');
    Array.from(oldScript.attributes).forEach(attr =>
      newScript.setAttribute(attr.name, attr.value)
    );

    // 3c) Se è inline, copia il contenuto
    if (!oldScript.src) {
      newScript.textContent = oldScript.textContent;
    }

    // 3d) Appendi nel container scelto
    container.appendChild(newScript);
  });
}